import { Link, useLocation } from "@tanstack/react-router";
import { Phone } from "lucide-react";
import { srcSetFor } from "@/lib/responsive";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo.png";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "Services", path: "/services" },
  { label: "Our Work", path: "/our-work" },
  { label: "About", path: "/about" },
  { label: "FAQ", path: "/faq" },
  { label: "Contact", path: "/contact" },
];

const PageNav = () => {
  const location = useLocation();

  return (
    <div className="container mx-auto px-4 lg:px-8 py-4">
      <div className="flex items-center justify-between">
        <Link to="/" className="flex-shrink-0">
          <img src={logo} srcSet={srcSetFor(logo)} sizes="300px" alt="JTB Floors" width={1536} height={1024} decoding="async" className="h-10 w-auto" />
        </Link>
        <nav className="hidden md:flex items-center gap-1" aria-label="Main navigation">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                location.pathname === link.path
                  ? "text-primary font-semibold"
                  : "text-foreground/80 hover:text-primary"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          <Button variant="outline" size="sm" asChild className="gap-2">
            <Link to="/contact" hash="form">Request Estimate</Link>
          </Button>
          <Button asChild size="sm" className="btn-shine gap-2">
            <a href="tel:17739342004">
              <Phone className="w-4 h-4" /> Call Now
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PageNav;
